
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';
const Hero = () => {
  return <section className="min-h-[80vh] flex flex-col justify-center items-center px-6 pt-20">
      <div className="max-w-3xl w-full mx-auto text-center flex flex-col items-center animate-fade-in">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-redflags-dark mb-6 tracking-tight">
          About to start a new job? <br className="hidden md:block" /> Check for RedFlags
        </h1>
        
        <p className="text-redflags-gray text-lg md:text-xl mb-8 max-w-2xl text-center">
          Australia's Most Valuable AI Powered<br />
          Pre-Employment Company Review Platform
        </p>
        
        <div className="w-full max-w-md">
          <Button asChild size="lg" className="bg-redflags-red hover:bg-redflags-red/90 text-white w-full">
            <Link to="/companies" className="flex items-center justify-center gap-2">
              Search companies
              <Search className="w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
};
export default Hero;
